import { SELECTED_CATEGORY, SELECTED_TEST } from "./selectConstants";

export const selectedCategory = selectedCategory => {
    return {
        type: SELECTED_CATEGORY,
        payload: selectedCategory
    };
};

export const selectedTest = selectedTest => {
    return {
        type: SELECTED_TEST,
        payload: selectedTest
    };
};
